import { AMENITIES } from '@/components/SearchForm/constants'
import { useRouter } from 'next/router'

export default function useSEMSearchHeadline() {
  const { query } = useRouter()
  const { SEMSearch, SEMSEARCH } = query
  const semSearchParam = (
    (SEMSearch || SEMSEARCH) as string | undefined
  )?.toUpperCase() as keyof typeof AMENITIES
  return AMENITIES[semSearchParam]
}
